import BaseModule from '@cv/store/base-module'
import axios from 'axios'

interface AccountMediaTag {
	_id: string
	account: string
	media: string
	tags: string[]
}

export default BaseModule({
	name: 'account-media-tags',
	actions: {
		async setTags(context, { mediaId, tags }: { mediaId: string; tags: string[] }) {
			console.log({
				mediaId,
				tags
			})
			tags = [...new Set(tags)]
			const existing = context.getters.forAccountAndMedia(mediaId)
			if (!existing) {
				return context.dispatch('create', {
					account: context.rootGetters['account/selected']._id,
					media: mediaId,
					tags
				})
			} else {
				return context.dispatch('update', {
					...existing,
					tags
				})
			}
		}
	},
	getters: {
		forAccount: (state, getters, rootState, rootGetters) => {
			const selectedAccount = rootGetters['account/selected']
			return getters.all.filter(object => object.account === selectedAccount._id || false)
		},
		optionsForAccount: (state, getters, rootState, rootGetters) => {
			return [...new Set(getters.forAccount.map(object => object.tags).flat())].filter(
				Boolean
			)
		},
		forAccountAndMedia: (state, getters, rootState, rootGetters) => mediaId => {
			return getters.forAccount.find(object => object.media === mediaId || false)
		},
		tagsForAccountAndMedia: (state, getters, rootState, rootGetters) => mediaId => {
			return getters.forAccountAndMedia(mediaId)?.tags || []
		}
	}
})
